module.exports = __webpack_public_path__ + "img/Archiv_2018.0db1e2d1.jpeg";